import CrudRequest from 'Domain/CrudRequest';

export default class TaxScoreRequest extends CrudRequest {
  static baseUrl() {
    return 'v1/controleDeTaxas';
  }
}
